export default __webpack_public_path__ + "print.4e143c220b2344c9.svg";